module.exports = __webpack_public_path__ + "static/media/perfil.f5ea468e.svg";